import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchGroupContactsFailure,
  fetchGroupContactsSuccess,
} from "../slices/features/groupContacts";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* groupContactsSaga(action: any) {
  const { payload } = action;
  const { id, groupId, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.getGroupContacts,
      baseUrl,
      id,
      groupId,
      meta
    );

    yield put(fetchGroupContactsSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchGroupContactsFailure({ statusCode, statusText }));
  }
}

export function* watchGroupContact() {
  yield takeLatest(RequestTypes.GET_GROUP_CONTACTS_REQUEST, groupContactsSaga);
}
